import { render, staticRenderFns } from "./HubContainer.vue?vue&type=template&id=4c030c18&scoped=true"
import script from "./HubContainer.vue?vue&type=script&lang=js"
export * from "./HubContainer.vue?vue&type=script&lang=js"
import style0 from "./HubContainer.vue?vue&type=style&index=0&id=4c030c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c030c18",
  null
  
)

export default component.exports